// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */", "",{"version":3,"sources":["styles.sass"],"names":[],"mappings":"AAAA,8EAAA","file":"styles.sass","sourcesContent":["/* You can add global styles to this file, and also import other style files */\n"]}]);
// Exports
module.exports = exports;
